import React from 'react'
import './Footer.css'

const Footer = () => {

    return (
    <div className="Footer" style={{}}>
        <div className='FooterMenu'>
            <div className='Trademark'>
                <i class="fas fa-copyright"></i>
                {(new Date()).getFullYear()}
                <span>CAIGOY CREATIONS</span> | <span>ALL RIGHTS RESERVED</span>
            </div>
            <div className='SocialMedia'>
                <a href="https://www.instagram.com/caigoycreations/" target='_blank'><i class="fab fa-instagram"></i></a>
                <a href="https://www.facebook.com/caigoycreations" target='_blank'><i class="fab fa-facebook-f"></i></a>
            </div>
        </div>

        <div className='FooterBottom'>

        </div>
    </div>
    )
}

export default Footer